import React from "react";
import { useAuth } from "./AuthContext";
import "./SubscriptionSection.css";

export default function SubscriptionSection() {
  const { user } = useAuth();

  const handleUpgrade = (planCode) => {
    if (!user) {
      alert("Please log in to upgrade.");
      return;
    }

    const BACKEND_URL = "https://api.jobfax.app"; 

    let TOKEN_URL = "";
    if (planCode === 'BASIC') {
      TOKEN_URL = "https://www.convergepay.com/hosted-payments?ssl_txn_auth_token=QxbDD%2FrbRhy62%2BeAXqLYiwAAAZu%2BfHB%2F"; 
    } else if (planCode === 'PRO') {
      TOKEN_URL = "https://www.convergepay.com/hosted-payments?ssl_txn_auth_token=qQduM7AcSCGmvXZnvuY0oQAAAZu%2BfnD%2F";
    }

    const userId = user.id || user._id || "UNKNOWN";
    // We use the user's email for the description to match the XML query
    const userEmail = user.email; 
    const trackingId = `${userId}_${planCode}`; 

    const webhookUrl = `${BACKEND_URL}/api/billing/converge/webhook`;
    const finalUrl = `${TOKEN_URL}&ssl_customer_code=${trackingId}&ssl_invoice_number=${Date.now()}&ssl_description=${encodeURIComponent(userEmail)}&ssl_result_url=${encodeURIComponent(webhookUrl)}`;

    window.location.href = finalUrl;
  };

  return (
    <div className="sub-wrap">
      <div className="sub-inner">
        <div className="sub-header">
          <h3>Upgrade Your Account</h3>
          <p>Choose the plan that fits your job search needs.</p>

          <p className="sub-terms-note">
            By purchasing a subscription, you agree to the{" "}
            <a
              href="/eula.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              EULA and Terms of Service
            </a>
            .
          </p>
        </div>

        
        <div className="sub-grid">
          {/* THE $5 BASIC CARD */}
          <div className="sub-card">
            <div className="sub-title">Weekly Basic</div>
            <div className="sub-price">$5</div>
            <p className="text-sm mt-2 mb-4 text-gray-400">Limited weekly reports</p>
            <button 
              onClick={() => handleUpgrade('BASIC')}
              className="auth-button"
              style={{ width: '100%', backgroundColor: '#4b5563' }}
            >
              Get Basic
            </button>
          </div>

          {/* THE $20 PRO CARD */}
          <div className="sub-card highlight">
            <div className="sub-title">Weekly Pro</div>
            <div className="sub-price">$20</div>
            <p className="text-sm mt-2 mb-4 text-gray-200">Unlimited access & deep scans</p>
            <button 
              onClick={() => handleUpgrade('PRO')}
              className="auth-button"
              style={{ width: '100%' }}
            >
              Get Pro
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}